/**
 * Connector brand mark: local SVG when we have one, else the letter tile.
 * Logos live under /v2/assets/connectors/ (no CDN).
 */

import { el } from '../../core/dom.js';
import { letterOf } from './catalogue.js';

/** Provider / MCP slug → file under /v2/assets/connectors/ */
const LOGO_FILE = {
  'google-ads': 'googleads.svg',
  admob: 'admob.svg',
  'apple-search-ads': 'applesearchads.svg',
  applovin: 'applovin.svg',
  appsflyer: 'appsflyer.svg',
  'app-store-connect': 'appstore.svg',
  firebase: 'firebase.svg',
  github: 'github.svg',
  'google-analytics': 'googleanalytics.svg',
  'google-play': 'googleplay.svg',
  mixpanel: 'mixpanel.svg',
  posthog: 'posthog.svg',
  revenuecat: 'revenuecat.svg',
  slack: 'slack.svg',
  stripe: 'stripe.svg',
};

export function logoSrc(slug) {
  const key = String(slug || '').trim().toLowerCase();
  const file = LOGO_FILE[key];
  return file ? `/v2/assets/connectors/${file}` : '';
}

/**
 * @param {string} slug provider or MCP server name
 * @param {string} [title] display name (letter fallback)
 * @param {{ inverted?: boolean }} [opts]
 */
export function cxMark(slug, title, opts = {}) {
  const letter = letterOf(title || slug);
  const src = logoSrc(slug);
  const classes = `cx-mark${opts.inverted ? ' is-inv' : ''}${src ? ' has-logo' : ''}`;
  if (!src) {
    return el('span', { class: classes, 'aria-hidden': 'true' }, letter);
  }
  return el('span', { class: classes, 'aria-hidden': 'true' },
    el('img', { src, alt: '', width: '22', height: '22', decoding: 'async' }));
}
